(function () {
  function closeDrawer() {
    var closeBtn = document.querySelector('#filters-drawer .theme-drawer__close-button');
    if (closeBtn) closeBtn.click();
  }

  function init() {
    var dialog = document.querySelector('#filters-drawer .theme-drawer__dialog');
    if (!dialog || dialog.dataset.cellfyAutoCloseInit === 'true') return;
    dialog.dataset.cellfyAutoCloseInit = 'true';

    // Fecha ao tirar o mouse de cima do painel
    var leaveTimer = null;
    dialog.addEventListener('mouseleave', function () {
      leaveTimer = setTimeout(closeDrawer, 300);
    });
    dialog.addEventListener('mouseenter', function () {
      if (leaveTimer) clearTimeout(leaveTimer);
    });

    // Fecha logo depois de aplicar um filtro (marcar/desmarcar opção)
    dialog.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[type="checkbox"], input[type="radio"]')) {
        setTimeout(closeDrawer, 500);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  // O painel é criado/reconectado quando o drawer abre pela primeira vez
  var observer = new MutationObserver(function () {
    init();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();